import { MessageHubResponse } from '@acme/api';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { config } from '../lib/config';
import { signalRService } from '../lib/signalRService';
import { MessageHubMessage, getChatIdFromMessage } from './types';

// Events
export const connect = createEvent();
export const disconnect = createEvent();
export const connectionChanged = createEvent<boolean>();
export const messageReceived = createEvent<MessageHubResponse>();

// Effects
export const connectFx = createEffect(async () => {
  const token = JSON.parse(localStorage.getItem('token') as string);
  await signalRService.connect(config.signalR.hubUrl, token?.accessToken);
});

export const disconnectFx = createEffect(async () => {
  await signalRService.disconnect();
});

// Stores
export const $isConnected = createStore(false)
  .on(connectionChanged, (_, connected) => connected)
  .reset(disconnectFx.done);

export const $isConnecting = connectFx.pending;

// Sample для связи событий с эффектами
sample({
  clock: connect,
  target: connectFx,
});

sample({
  clock: disconnect,
  target: disconnectFx,
});

// Подписка на SignalR события
signalRService.onConnectionChange((connected) => {
  connectionChanged(connected);
});

signalRService.onMessage((message) => {
  messageReceived(message);
});

// Вспомогательный store для маппинга сообщений на chatId
export const $lastMessage = createStore<MessageHubMessage | null>(null).on(
  messageReceived,
  (_, message) => ({
    ...message,
    chatId: getChatIdFromMessage(message),
  })
);
